<script setup>
import { cn } from "@/lib/utils";
import { useVModel } from "@vueuse/core";
import { useSlots, ref } from "vue";
import { Button } from "@/components/v4/button";

const props = defineProps({
  defaultValue: String,
  modelValue: String,
  class: String,
  placeholder: String,
  onClickPrefix: Function,
  onClickSuffix: Function,
  dataTestid: String,
  disabled: Boolean,
  readonly: Boolean,
  type: {
    type: String,
    default: "text",
  },
});

const slots = useSlots();

const emits = defineEmits(["update:modelValue", "input", "keyup.enter"]);

const modelValue = useVModel(props, "modelValue", emits, {
  passive: true,
  defaultValue: props.defaultValue,
});

const inputRef = ref();

defineExpose({
  inputRef,
});
</script>

<template>
  <div class="vf-relative vf-w-full">
    <Button
      variant="ghost"
      class="vf-absolute vf-top-1/2 -vf-translate-y-1/2 vf-left-3 !vf-p-0"
      @click="onClickPrefix"
    >
      <slot name="prefix" />
    </Button>
    <input
      ref="inputRef"
      :disabled="disabled || readonly"
      v-model="modelValue"
      :auto-focus="false"
      :data-testid="dataTestid"
      :placeholder="placeholder"
      :type="type"
      @input="$emit('input', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @keyup.enter="$emit('keyup.enter', $event)"
      @keyup.escape="$emit('keyup.escape', $event)"
      :class="
        cn(
          slots.prefix ? 'vf-pl-10' : 'vf-pl-3',
          slots.suffix ? 'vf-pr-9' : 'vf-pr-3',
          'vf-flex vf-h-10 vf-rounded-md vf-border vf-py-2 vf-text-sm vf-w-full t',
          'focus-visible:vf-outline-none focus-visible:vf-ring-2',
          'focus-visible:vf-ring-offset-2 disabled:vf-cursor-not-allowed disabled:vf-opacity-50',
          props.class
        )
      "
    />
    <Button
      variant="ghost"
      class="vf-absolute vf-top-1/2 -vf-translate-y-1/2 vf-right-3 !vf-p-0"
      @click="onClickSuffix"
    >
      <slot name="suffix" />
    </Button>
  </div>
</template>
